import { MenuItem } from '../../models';

/** holds items for my progress dropdown used in navbar */
export const MY_PROGRESS_LIST: MenuItem[] = [
  { title: 'COVID Learning Loss Checkup', link: '/covid-learning-loss-report-math' },
  { title: 'National Percentile Rank', link: '/map-summary' },
  { title: 'Study Visualizer', link: '/habits/visualizer' },
];
